<template>
  <div class="dropdown-input-container mb-3">
    <label>
      <question-display :question="question" customClass="header-dropdown"></question-display>
    </label>

    <multiselect
      v-model="inputValue"
      :options="dropdownOptions"
      :searchable="true"
      :close-on-select="true"
      :clear-on-select="false"
      label="name"
      track-by="value"
      :filter-method="customFilter"
      :custom-label="customLabel"
      @update:modelValue="updateInput"
    />

    <div v-if="isOthersSelected" class="mt-2">
      <label for="others-input">Please specify:</label>
      <input
        id="others-input"
        v-model="othersValue"
        type="text"
        class="form-control form-control-sm"
        @input="updateOthersInput"
        placeholder="Enter your value"
      />
    </div>

    <small v-if="showValidation && question.required && !inputValue && !isOthersSelected" class="text-danger">
      This field is required.
    </small>
    <small v-if="showValidation && question.required && isOthersSelected && !othersValue" class="text-danger">
      Please specify the 'Others' value.
    </small>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import dropdownValues from "@/assets/data/dropdown-values/dropdown.json";
import surveyService from "@/services/surveyService";
import QuestionDisplay from "../utils/QuestionDisplay.vue";

export default {
  components: {
    QuestionDisplay,
    Multiselect,
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean,
  },
  data() {
    return {
      dropdownOptions: [],
      inputValue: this.getSelectedOption(surveyService.getAnswer(this.question.id)),
      othersValue: "",
      isOthersSelected: false,
    };
  },
  methods: {
    updateInput() {
      if (this.inputValue?.value === '__others__') {
        this.isOthersSelected = true;
        // Don't update surveyService immediately, wait for othersValue
      } else {
        this.isOthersSelected = false;
        this.othersValue = ""; // Clear others value if a different option is selected
        surveyService.setAnswer(this.question.id, this.inputValue?.value);
        this.$emit("input", this.inputValue);
      }
    },
    updateOthersInput() {
      surveyService.setAnswer(this.question.id, this.othersValue);
      this.$emit("input", { value: '__others__', name: `Others: ${this.othersValue}` });
    },
    getSelectedOption(value) {
      console.log(surveyService.getAnswer(this.question.id));
      return this.dropdownOptions?.find(option => option.value === value) || null;
    },
    loadDropdownValues() {
      const savedAnswer = surveyService.getAnswer(this.question.id);

      if (this.question["selection-list"]) {
        const key = this.question["selection-list"].value;
        this.dropdownOptions = [...(dropdownValues[key] || []), { value: '__others__', name: 'Others' }];
      } else {
        this.dropdownOptions = [...(this.question.options || []), { value: '__others__', name: 'Others' }];
      }

      // Try to match the saved answer with dropdown options
      const matchedOption = this.dropdownOptions.find(option => option.value === savedAnswer);

      if (matchedOption) {
        this.inputValue = matchedOption;
        this.isOthersSelected = matchedOption.value === '__others__';
        this.othersValue = this.isOthersSelected ? savedAnswer : '';
      } else if (savedAnswer) {
        // Saved answer not in options — select "Others" and set the text input
        this.inputValue = { value: '__others__', name: 'Others' };
        this.isOthersSelected = true;
        this.othersValue = savedAnswer;
      } else {
        // No answer — clear fields
        this.inputValue = null;
        this.isOthersSelected = false;
        this.othersValue = '';
      }
    },

    customLabel(option) {
      if (this.question.id === '1b') {
        return `${option.name} (${option.value})`;
      }
      return `${option.name}`;
    },
    customFilter(option, search) {
      const searchText = search.toLowerCase();
      return (
        option.name?.toLowerCase().includes(searchText) ||
        option.value?.toLowerCase().includes(searchText)
      );
    },
  },
  watch: {
    question(newQuestion) {
      this.inputValue = this.getSelectedOption(surveyService.getAnswer(newQuestion.id)) || null;
      this.loadDropdownValues();
    },
  },
  mounted() {
    this.loadDropdownValues();
  },
};
</script>